// src/components/LanguageSelector.js
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const languages = [
  { code: 'es', name: 'Español', flag: 'https://flagcdn.com/48x36/es.png' },
  { code: 'en', name: 'English', flag: 'https://flagcdn.com/48x36/us.png' },
];

const LanguageSelector = () => {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);

  const currentLang =
    languages.find(l => l.code === i18n.language) || languages[0];

  const changeLanguage = (code) => {
    i18n.changeLanguage(code);
    localStorage.setItem('language', code);
    setOpen(false);
  };

  return (
    <div className="relative ml-4">
      {/* Botón */}
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center space-x-3 bg-white border border-gray-200 rounded-xl px-3 py-2 shadow-sm hover:shadow-md transition-all"
      >
        <img
          src={currentLang.flag}
          alt={currentLang.name}
          className="w-7 h-7 rounded-sm shadow-sm"
        />
        <span className="font-semibold text-primary text-sm">
          {currentLang.code.toUpperCase()}
        </span>
        <svg
          className={`w-4 h-4 text-gray-600 transition ${open ? 'rotate-180' : ''}`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {/* Dropdown */}
      {open && (
        <div className="absolute right-0 mt-2 w-48 bg-white rounded-xl shadow-xl border border-gray-100 overflow-hidden z-50">
          {languages.map(lang => (
            <button
              key={lang.code}
              onClick={() => changeLanguage(lang.code)}
              className={`w-full px-4 py-3 flex items-center space-x-3 transition-all
                ${i18n.language === lang.code
                  ? 'bg-orange-500 text-white'
                  : 'text-gray-800 hover:bg-orange-100'
                }`}
            >
              <img src={lang.flag} alt={lang.name} className="w-8 h-8 rounded-sm shadow" />
              <span className="font-medium">{lang.name}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;
